import {FC} from 'react';
import {Box} from '@mui/material';
import {cardListSx} from './CardList.sx';
import {CardListProps} from './CardList.types';

/**
 * The card form of a table. Wraps whatever a list renders instead of its grid, so every list on a
 * narrow screen lays its cards out the same way.
 */
export const CardList: FC<CardListProps> = ({children}) => <Box sx={cardListSx}>{children}</Box>;
